import { healthSchema } from '@xphoto/shared';

/**
 * `buildId` embarqué au build (injecté par Vite `define`, cf. `vite.config.ts`).
 * Vaut `'dev'` en dev/test (aucune détection de version alors).
 */
export const EMBEDDED_BUILD_ID: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';

/** Interroge `/api/health` et renvoie le `buildId` serveur, ou `null` si injoignable. */
export async function fetchServerBuildId(signal?: AbortSignal): Promise<string | null> {
  try {
    const res = await fetch('/api/health', signal ? { signal } : {});
    if (!res.ok) return null;
    const parsed = healthSchema.safeParse(await res.json());
    return parsed.success ? parsed.data.buildId : null;
  } catch {
    return null;
  }
}

/**
 * Une nouvelle version est disponible si le build serveur diffère du build
 * embarqué. En dev (`EMBEDDED_BUILD_ID === 'dev'`) on ne signale jamais.
 */
export function isNewerBuild(serverBuildId: string | null): boolean {
  if (EMBEDDED_BUILD_ID === 'dev') return false;
  if (!serverBuildId) return false;
  return serverBuildId !== EMBEDDED_BUILD_ID;
}
